import { mapToList } from "./utils";

export const EnumStoreGrade = {
  FIVE: "5星",
  FOUR: "4星",
  THREE: "3星",
  TWO: "2星",
  ONE: "1星",
};

export const StoreGradeToTextMap = new Map([
  [EnumStoreGrade.FIVE, "5星"],
  [EnumStoreGrade.FOUR, "4星"],
  [EnumStoreGrade.THREE, "3星"],
  [EnumStoreGrade.TWO, "2星"],
  [EnumStoreGrade.ONE, "1星"],
]);

export const StoreGradeList = mapToList(StoreGradeToTextMap);
